<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/yygg">医院公告</router-link> >
      {{ current.title }}
    </div>

    <div class="container-width">
      <ARTICLE
        :current="current"
        :before="before"
        :after="after"
        :showBeforeAfter="showBeforeAfter"
        :showorigin="showorigin"
        @changePage="handleChangePage"
      ></ARTICLE>
    </div>
  </div>
</template>
<script>
import service from "../../../service/index";
import BANNER from "../../../components/banner/sjkd";
export default {
  name: "YYGGARTICLE",
  data() {
    return {
      navigationData: [
        {
          name: "医院公告",
          path: "/sjkd/yygg",
        },
      ],
      currentPath: "/sjkd/yygg",
      current: {
        title: "",
        description: "",
        releaseDate: "",
        views: "",
        origin: "",
      },
      // 上一篇
      before: {
        title: "",
        id: "",
        active: false,
      },
      // 下一篇
      after: {
        title: "",
        id: "",
        active: false,
      },
      showBeforeAfter: true, //是否显示上一篇 下一篇
      showorigin: true, //是否显示来源 发布时间 点击次数
    };
  },
  components: { BANNER },
  computed: {},
  created() {
    this.init();
  },
  beforeMount() {},
  methods: {
    init() {
      let parmes = {
        id: this.$route.query.id,
      };
      service.getwzHospitalNoticeInfo(parmes, (res) => {
        res.current.releaseDate = res.current.releaseDate
          ? res.current.releaseDate.split(" ")[0]
          : "";
        res.current.description = res.current.description.replace(
          /<table[^>]*>/gi,
          function (match, capture) {
            return match.replace(/width=\"(.*)\"/gi, "style='width:90%'");
          }
        );
        this.current = { ...res.current };
        if (res.before) {
          this.before = { ...res.before };
          this.before.active = true;
        } else {
          this.before.title = "已经没有上一篇";
          this.before.active = false;
        }
        if (res.after) {
          this.after = { ...res.after };
          this.after.active = true;
        } else {
          this.after.title = "已经没有下一篇";
          this.after.active = false;
        }
      });
    },
    // 上一篇 下一篇
    handleChangePage(id) {
      const query = JSON.parse(JSON.stringify(this.$route.query)); // 获取路由参数信息
      query.id = id; //改变参数
      this.$router.push({ path: this.$route.path, query }); //更新路由
      this.init();
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style>
</style>
